import React from 'react'
import './ValueAddedServices.css'

const ValueAddedServices = ({ transporter_data }) => {
    const valueaddedservices = transporter_data?.value_added_services ?? []

    return (
        <div className="valueaddedservicescard">
            <div className="valueaddedservicescontainer row">
                <div className="col-12">
                    <h3 className="data_header">Value Added Services</h3>
                </div>
                <div className="col-12">
                    {valueaddedservices.length !== 0 ? (
                        valueaddedservices.map((item, i) => (
                            <div className="vas" key={i}>
                                <span>{item}</span>
                            </div>
                        ))
                    ) : (
                        'Details not available'
                    )}
                </div>
            </div>
        </div>
    )
}

export default ValueAddedServices
